export enum ConfirmDialogTypes {
  COMMON,
  PAY_WITH_SUBSCRIPTION
}
